var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GDX"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-79",
    d: "M28 0c15.5 0 28 12.5 28 28S43.5 56 28 56 0 43.5 0 28 12.5 0 28 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-134",
    className: "st1",
    d: "M18.4 24.5h19.3l-4.8-9.6h-9.6l-4.9 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-134-Copy",
    className: "st1",
    d: "M29.8 37.6H49L44.2 28h-9.6l-4.8 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-134-Copy-2",
    className: "st1",
    d: "M7 37.6h19.3L21.4 28h-9.6L7 37.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.555037f72f9b32b1a8257002989ae06b.svg";
export { ForwardRef as ReactComponent };